import { CloseCircleTwoTone } from "@ant-design/icons";
import { Card, Flex, InputNumber, Space } from "antd";
import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import { useEffect, useState } from "react";

interface IFixWidthDataColumnSpecsProps {
    columnSpecs: ISchemaFileColumnSpec[];
    onColumnSpecsChange: (columnSpecs: ISchemaFileColumnSpec[]) => void;
    onSpecSelected: (index: number) => void;
}

const FixWidthDataColumnSpecs = ({ onColumnSpecsChange, columnSpecs, onSpecSelected }: IFixWidthDataColumnSpecsProps) => {
    const [columns, setColumns] = useState(columnSpecs);
    const [selectedIndex, setSelectedIndex] = useState(-1);

    useEffect(() => {
        setColumns(columnSpecs);
    }, [columnSpecs]);

    const onChange = (index: number, value: number | null, property: "start" | "end") => {
        const updatedColumns = [...columns];
        updatedColumns[index] = { ...updatedColumns[index], [property]: value };
        setColumns(updatedColumns);
        onColumnSpecsChange && onColumnSpecsChange(updatedColumns);
    };

    const removeColumnSpec = (index: number) => {
        const updatedColumns = [...columns];
        updatedColumns.splice(index, 1);
        setColumns(updatedColumns);
        onColumnSpecsChange && onColumnSpecsChange(updatedColumns);
        if (index === selectedIndex) {
            onColumnSpecClicked(-1);
        }
    };

    const onColumnSpecClicked = (index: number) => {
        setSelectedIndex(index);
        onSpecSelected && onSpecSelected(index);
    };

    return (
        <FlexContainerLayout>
            <Flex wrap={false} gap={6} className={columns?.length > 2 ? "pb-2" : ""}>
                {columns.map((column, index) => (
                    <Card
                        onClick={(event) => {
                            event.stopPropagation && event.stopPropagation();
                            onColumnSpecClicked(index);
                        }}
                        key={column.name || index}
                        size="small"
                        title={column.name}
                        extra={
                            <CloseCircleTwoTone
                                onClick={(event) => {
                                    event.stopPropagation && event.stopPropagation();
                                    removeColumnSpec(index);
                                }}
                            />
                        }
                        className={selectedIndex === index ? "selected-column-spec-card" : "column-spec-card"}
                    >
                        <Space>
                            <Space.Compact>
                                <Space.Addon>Start</Space.Addon>
                                <InputNumber
                                    style={{ minWidth: "8rem", maxWidth: "8rem" }}
                                    min={1}
                                    defaultValue={1}
                                    value={column.start}
                                    onChange={(value) => onChange(index, value, "start")}
                                />
                            </Space.Compact>
                            <Space.Compact>
                                <Space.Addon>End</Space.Addon>
                                <InputNumber
                                    style={{ minWidth: "8rem", maxWidth: "8rem" }}
                                    min={1}
                                    defaultValue={1}
                                    value={column.end}
                                    onChange={(value) => onChange(index, value, "end")}
                                />
                            </Space.Compact>
                        </Space>
                    </Card>
                ))}
            </Flex>
        </FlexContainerLayout>
    );
};

export default FixWidthDataColumnSpecs;
